import React, { useEffect, useState } from 'react';
// import PropTypes from 'prop-types';
import moment from 'moment-timezone';

const Button = ({ text, status, textColor = "se-text-black", onClick = () => { }, time_conditional, orderDetails, setOderNextDayProcessMessage }) => {

    const [backgroundColor, setBackgroundColor] = useState('#EFC41A');
    const [textMessage, setTextMessage] = useState('');


    useEffect(() => {
        if (time_conditional) {
            let getOrderProcessingMessage = (orderDateTime, timezone = 'Asia/Kolkata') => {
                const systemMoment = moment.tz(timezone); // Get current system time in the given timezone
                const orderMoment = moment.tz(orderDateTime, timezone); // Convert order time to store timezone

                // Extract only the time (HH:mm) for comparison, ignoring the date
                const systemTime = systemMoment.format('HH:mm');
                const orderTime = orderMoment.format('HH:mm');

                const eightAM = "08:00";
                const eightPM = "20:00";

                let status = "Packing Your Order";
                let message = "";
                let order_confirmation_msg = "";

                // console.log("System Time:", systemMoment.format('YYYY-MM-DD HH:mm:ss'));
                // console.log("Order Time:", orderMoment.format('YYYY-MM-DD HH:mm:ss'));

                // If system time is between 8:00 AM - 8:00 PM → Normal Order Processing
                if ((systemTime >= eightAM && systemTime < eightPM) || (orderTime < eightPM && orderTime > eightAM)) {
                    status = "Packing Your Order";
                } else {
                    // If system time is after 8:00 PM OR before 8:00 AM, check order time
                    if (systemTime >= eightPM || systemTime < eightAM) {
                        status = "Order Confirmed";

                        // Determine correct processing date for 8 AM based on system time
                        let processingDate;
                        if (systemTime >= eightPM) {
                            processingDate = systemMoment.clone().add(1, 'day').format('DD MMM YYYY'); // Next day
                        } else {
                            processingDate = systemMoment.format('DD MMM YYYY'); // Same day
                        }

                        order_confirmation_msg = `Your order will get processed at 8:00 AM on ${processingDate}`;
                    }
                }

                return {
                    status,
                    message,
                    order_confirmation_msg
                };
            }
            const result = getOrderProcessingMessage(orderDetails.created_at);
            // console.log("🚀 ~ useEffect ~ result:", result);
            // setBackgroundColor('#EFC41A');
            setTextMessage(result?.status);
            setOderNextDayProcessMessage(result?.order_confirmation_msg);
        }
        else {
            switch (status) {
                case 'NEW':
                    setBackgroundColor('#EFC41A');
                    setTextMessage(text);
                    break;
                case 'PICKED_UP':
                    setBackgroundColor('#EFC41A');
                    setTextMessage("Your order is on the way");
                    break;
                case 'OUT_FOR_DELIVERY':
                    setBackgroundColor('#EFC41A');
                    setTextMessage("Your order is out for delivery");
                    break;
                case 'RESCHEDULE':
                    setBackgroundColor('#EFC41A');
                    setTextMessage("Order has been rescheduled");
                    break;
                case 'DELIVERED':
                    setBackgroundColor('#6DC2FF');
                    setTextMessage(text);
                    break;
                case 'PARTIAL_DELIVERED':
                    setBackgroundColor('#6DC2FF');
                    setTextMessage(text);
                    break;
                case 'CANCELLED':
                    setBackgroundColor('#FF9170');
                    setTextMessage(text);
                    break;
                default:
                    setBackgroundColor('#EFC41A');
                    setTextMessage("In transit");
            }
        }
    }, [status])


    return (<div className='se-ml-auto se-mr-auto se-w-[95%]'>
        <button
            className={`${textColor} se-w-full se-px-4 se-py-2 se-rounded`}
            onClick={onClick}
            style={{ backgroundColor }}
        >
            <b>{textMessage}</b>
        </button>
    </div>);
};

// Button.propTypes = {
//     text: PropTypes.string.isRequired,
//     textColor: PropTypes.string.isRequired,
//     onClick: PropTypes.func.isRequired,
//     status: PropTypes.string,
// };

export default Button;